(function() {
  'use strict';

  angular.module('component.userFields', []);
})();
